import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import i18n from 'i18n'
import {useTranslation} from 'react-i18next'

const AuthLayout = () => {
  const {t} = useTranslation()

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) root.style.height = '100%'
    return () => {
      if (root) root.style.height = 'auto'
    }
  }, [])

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang)
  }

  return (
    <div className='d-flex flex-column min-vh-100 bg-light'>
      {/* Top Navigation */}
      <div className='px-10 py-4 d-flex justify-content-between align-items-center bg-white shadow-sm'>
        <div className='d-flex align-items-center gap-3'>
          <span className='fw-bold fs-3 text-primary'>E-Academy</span>
        </div>

        {/* Language Switch */}
        <div className='d-flex align-items-center gap-4'>
          <span
            className='text-primary fw-bold cursor-pointer'
            onClick={() => handleChangeLanguage('fr')}
          >
            FR
          </span>
          <span
            className='text-primary fw-bold cursor-pointer'
            onClick={() => handleChangeLanguage('en')}
          >
            EN
          </span>
        </div>
      </div>

      {/* Main Layout */}
      <div className='d-flex flex-grow-1'>
        {/* Left side (Login Form Section) */}
        <div className='col-12 col-lg-5 d-flex justify-content-center align-items-center p-10'>
          <div
            className='bg-white shadow-lg rounded-4 p-10 w-100 border-light'
            style={{maxWidth: 460}}
          >
            <Outlet />
          </div>
        </div>

        {/* Right side (Academic Info Section) */}
        <div
          className='col-lg-7 d-none d-lg-flex flex-column justify-content-center p-10'
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/logo/new_bg.jpg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
          }}
        >
          {/* Soft overlay to match laptop screen brightness */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.10)',
            }}
          ></div>
          <div
            className='position-relative shadow-sm rounded-4 p-6'
            style={{
              maxWidth: 520,
              marginLeft: '5%',
              marginTop: 'auto',
              background: 'rgba(255,255,255,0.85)',
              backdropFilter: 'blur(3px)',
              borderRadius: '18px',
            }}
          >
            <h2 className='fw-bold mb-4 fs-2 text-dark'>{t('LOGIN.learning_experience_title')}</h2>

            <p className='text-primary fw-bold mb-4 fs-5'>
              {t('LOGIN.learning_experience_description')}
            </p>

            <div className='d-flex flex-column gap-3'>
              <div>
                <h5 className='fw-bold mb-1 fs-5 text-dark'>
                  <span className='fa fa-check-circle mx-2'></span>
                  {t('LOGIN.courses_supports_title')}
                </h5>
                <p className='text-primary fw-bold m-0 fs-6 mx-5'>
                  {t('LOGIN.courses_supports_description')}
                </p>
              </div>

              <div>
                <h5 className='fw-bold mb-1 fs-5 text-dark'>
                  <span className='fa fa-check-circle mx-2'></span>
                  {t('LOGIN.homework_evaluations_title')}
                </h5>
                <p className='text-primary fw-bold m-0 fs-6 mx-5'>
                  {t('LOGIN.homework_evaluations_description')}
                </p>
              </div>

              <div>
                <h5 className='fw-bold mb-1 fs-5 text-dark'>
                  <span className='fa fa-check-circle mx-2'></span>
                  {t('LOGIN.progress_attestations_title')}
                </h5>
                <p className='text-primary fw-bold m-0 fs-6 mx-5'>
                  {t('LOGIN.progress_attestations_description')}
                </p>
              </div>
            </div>

            <div className='mt-4 text-start'>
              <span className='text-primary fw-bold fst-italic fs-6'>
                ⭐ {t('LOGIN.quality_statement')}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className='text-center py-4 text-muted bg-white shadow-sm fs-6'>
        © SWISS UMEF {new Date().getFullYear()}
      </div>
    </div>
  )
}

export {AuthLayout}
